import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessStepReader extends ConnectBasicEntity {
cnxCode: string;
fileExtension: string;
fileName: string;
keepFileToExport: boolean | null;
linesToSkip: number | null;
processCode: string;
processStepCode: string;
readParams: string;
readQuery: string;
readSchema: string;
readTable: string;
removeFile: boolean | null;
sqlOrderField: string;
stopCondition: string;
stopField: string;
tsFileFormat: string;
visionCode: string;
witnessFileExtension: string;
}

